<template>
  <div class="navbar">
    <div class="navbar-menu">
      <hamburger
        id="hamburger-container"
        :is-active="sidebar.opened"
        class="hamburger-container"
        @toggleClick="toggleSideBar"
      />

      <!-- <breadcrumb id="breadcrumb-container" class="breadcrumb-container" /> -->
    </div>

    <div class="flex-fill"></div>

    <div class="navbar-menu">
      <screenfull
        id="screenfull"
        class="right-menu-item hover-effect"
      ></screenfull>

      <el-dropdown
        class="avatar-container right-menu-item hover-effect"
        trigger="click"
      >
        <div class="navbar-menu-item" title="用户">
          <el-tag type="" style="margin-right: 5px;">{{ name }}</el-tag>
          <el-tag type="success" style="margin-right: 5px;">{{ orgName }}</el-tag>
          <el-avatar
            :size="32"
            shape="square"
            :src="require('@/assets/img/nan.png')"
          ></el-avatar>
        </div>
        <el-dropdown-menu slot="dropdown">
          <!-- 路由跳转 -->
          <!-- <router-link to="/profile/index">
            <el-dropdown-item>用户中心</el-dropdown-item>
          </router-link> -->
          <!-- 外网跳转 -->
          <!-- <a
            target="_blank"
            href="https://github.com/PanJiaChen/vue-element-admin/"
          >
            <el-dropdown-item>Github</el-dropdown-item>
          </a> -->
          <!-- 退出系统 -->
          <el-dropdown-item divided @click.native="logout">
            <span style="display: block">退出</span>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
// import Breadcrumb from '@/components/Breadcrumb'
import Hamburger from "@/components/Hamburger";
import Screenfull from "@/components/Screenfull";
import { sessionStorageClear } from "@/utils/sessionStorageUtil.js";

export default {
  components: {
    // Breadcrumb,
    Hamburger,
    Screenfull,
  },
  computed: {
    ...mapGetters(["sidebar", "avatar", "device", "name","orgName"]),
  },
  methods: {
    toggleSideBar() {
      this.$store.dispatch("app/toggleSideBar");
    },
    async logout() {
      //后端无需处理，前端清空sessionstore即可
      //如后端需要处理登出事件，将下列代码放到axios成功回调函数中
      sessionStorageClear();
      this.$router.push(`/login`);
    },
  },
};
</script>

<style  scoped>
.navbar {
  height: 50px;
  padding: 0 30px 0 0;
  background-color: #fff;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);
}

.navbar .flex-fill {
  flex: 1;
}

.navbar .navbar-menu {
  width: auto;
  display: flex;
  flex-direction: row;
  align-items: center;
}

.navbar .navbar-menu .navbar-menu-item {
  width: auto;
  min-width: 40px;
  line-height: 50px;
  padding: 0 5px;
  height: 100%;
  display: flex;
  justify-content: center;
}

.navbar .navbar-menu .navbar-menu-item:hover {
  color: #6495ed;
}

.navbar .avatar-container {
  margin-right: 30px;
}

.navbar .avatar-container .avatar-wrapper {
  margin-top: 5px;
  position: relative;
}

.navbar .avatar-container .avatar-wrapper .user-avatar {
  cursor: pointer;
  width: 40px;
  height: 40px;
  border-radius: 10px;
}

.navbar .avatar-container .avatar-wrapper .el-icon-caret-bottom {
  cursor: pointer;
  position: absolute;
  right: -20px;
  top: 25px;
  font-size: 12px;
}

.navbar .hamburger-container {
  line-height: 46px;
  height: 100%;
  cursor: pointer;
  transition: background 0.3s;
  -webkit-tap-highlight-color: transparent;
}

.navbar .hamburger-container:hover {
  background: rgba(0, 0, 0, 0.025);
}
</style>
